module.exports = __webpack_public_path__ + "static/media/perfil.5f854060.PNG";